import React from 'react'
import Form from 'react-bootstrap/Form';
import toast from 'react-hot-toast';

const UploadFile = ({label, requiredStar, accept,value, setValue}) => {
  return (
   <>
        <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>{label} <span className='redStar'>{requiredStar}</span></Form.Label>
        <Form.Control type="file" accept={accept} onChange={(e)=>{
          const file = e.target?.files[0];
          if (file) {
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!allowedTypes.includes(file.type)) {
              toast.error('Only JPG, JPEG, PNG, and PDF files are allowed.');
              e.target.value = '';
              setValue(null);
              return;
            }
            setValue({file, name: e.target.value, type: file.type });
          } else {
            setValue(null);
          }
        }}/>
        <Form.Text style={{ color: '#007bff' }}>
          Allowed formats: JPG, JPEG, PNG, PDF (Max size: 5 MB)
        </Form.Text>
      </Form.Group>
   </>
  )
}

export default UploadFile